import type { ResourceProps } from 'react-admin';
import SellIcon from '@mui/icons-material/Sell';

import PricingRulesList from './PricingRulesList';
import PricingRulesCreate from './PricingRulesCreate';
import PricingRulesEdit from './PricingRulesEdit';

export { pricingRulesDataProvider } from './dataProvider';

const resource: ResourceProps = {
  name: 'resalePricing/pricingRules',
  list: PricingRulesList,
  create: PricingRulesCreate,
  edit: PricingRulesEdit,
  icon: SellIcon,
  options: { label: 'Pricing Rules' },
};

export default resource;
